import { Routes, Route, useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import {
  ValidateEmail,
  UploadDocuments,
  MainIndex,
  OTPscreen,
  MessageScreen
} from 'pages'

const HashToPathRedirector = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    // Only allow in-app paths. Block attempts to navigate to filesystem-like paths
    const isSafePath = path => {
      if (!path.startsWith('/')) return false
      if (path.includes('..')) return false
      // Block protocol-like and Windows drive paths
      if (path.includes('://')) return false
      if (/^[a-zA-Z]:[\\/]/.test(path)) return false
      if (
        path.startsWith('/var/') ||
        path.startsWith('/etc/') ||
        path.startsWith('/usr/')
      )
        return false
      return true
    }

    if (location.hash && location.hash.startsWith('#/')) {
      const target = location.hash.slice(1)
      if (!isSafePath(target)) return
      const basePath = location.pathname.replace(/\/+$/, '') || ''
      const resolved = `${basePath}${target}`
      navigate(resolved, { replace: true })
    }
  }, [location.hash, location.pathname, navigate])

  return null
}

const PublicHashApp = () => {
  return (
    <>
      <HashToPathRedirector />
      <Routes>
        <Route path="validate/email/:id" element={<ValidateEmail />} />
        <Route
          path="upload-documents/:contact_id?/:trip_id?/:type?"
          element={<UploadDocuments />}
        />
        <Route path="giveback-intake" element={<MainIndex />} />
        <Route path="giveback-intake/verify-otp" element={<OTPscreen />} />
        <Route path="giveback-intake/validate" element={<MessageScreen />} />
      </Routes>
    </>
  )
}

export default PublicHashApp
